import { render, staticRenderFns } from "./SunlightDialog.vue?vue&type=template&id=137a01d8"
import script from "./SunlightDialog.vue?vue&type=script&lang=js"
export * from "./SunlightDialog.vue?vue&type=script&lang=js"
import style0 from "./SunlightDialog.vue?vue&type=style&index=0&id=137a01d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports